<template>
  <div
    :class="[
      'tw-flex tw-flex-col tw-justify-center tw-cursor-pointer',
      'tw-px-6 apDesktop:tw-py-4 tw-py-3 tw-outline tw-outline-ap-gainsboro tw-outline-offset-[-2px] tw-outline-1',
      'apDesktop:tw-rounded-xl tw-rounded-[10px]',
      'tw-bg-white  tw-text-ap-nero',
      'tw-text-body-md-mobile apTablet2:tw-text-body-md-desktop ',
      // 'dark:tw-bg-ap-nero dark:tw-text-white dark:tw-outline-ap-night-rider ',
      'tw-transition-all tw-duration-150',
      { '!tw-outline-ap-dodger-blue !tw-outline-2': selected },
      { ' ': !hasSubtitle },
    ]"
    @click="onClick"
  >
    <span v-if="hasSubtitle" class="tw-text-ap-nobel tw-text-label-md-mobile apTablet2:tw-text-label-md-desktop">{{
      subtitle }}</span>
    <p class="tw-text-body-md-mobile-contact apTablet2:tw-text-body-md-desktop">
      {{ title }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';


const props = defineProps({
  value: {
    type: String,
    required: true
  },
  selected: {
    type: Boolean,
    default: false
  },
  hasSubtitle: {
    type: Boolean,
    default: false
  }
});

const title = computed(() => {
  if (props.hasSubtitle) {
    return props.value?.split(':')[1];
  }
  return props.value;
});

const subtitle = computed(() => {
  if (props.hasSubtitle) {
    return props.value?.split(':')[0];
  }
  return '';
});

function onClick() {
  emit('click');
}

const emit = defineEmits(['click']);

</script>

<style scoped></style>